<template>
  <div class="profile">

    <v-dialog
        v-model="dialogNewClient"
        width="500"
      >

        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Add a new client
          </v-card-title>

          <v-card-text>
            <v-text-field
             v-model="newClientName"
             :counter="10"
             label="Company name"
             required
           ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="createNewClient()"
            >
              Add client
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
          v-model="dialogNewUser"
          width="500"
        >

          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
              Add a new user
            </v-card-title>

            <v-card-text>
              <v-text-field
               v-model="newFirstName"
               :counter="10"
               label="First name"
               required
             ></v-text-field>
             <v-text-field
              v-model="newLastName"
              :counter="10"
              label="Last name"
              required
            ></v-text-field>
            <v-text-field
              v-model="newEmail"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
            <v-text-field
              v-model="newPassword"
              type="password"
              label="Password"
              required
            ></v-text-field>
            <v-select
              v-model="newCompany"
              :items="clients"
              item-text="name"
              item-value="name"
              :rules="[v => !!v || 'Item is required']"
              label="Company"
              required
            ></v-select>
            <v-switch
              v-model="newIsAdmin"
              :label="`Administrator: ${newIsAdmin.toString()}`"
            ></v-switch>
            <v-switch
              v-model="newIsSuspended"
              :label="`Suspended: ${newIsSuspended.toString()}`"
            ></v-switch>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="createNewUser()"
              >
                Create user
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <v-layout row wrap>
        <v-flex xs4>
          <v-card class="d-inline-block elevation-12">
              <v-navigation-drawer
                floating
                permanent
                stateless
                value="true"
              >
                <v-list>
                  <router-link to="/dashboard">
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon>home</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Home</v-list-tile-title>
                    </v-list-tile>
                  </router-link>

                  <v-list-group id="clients-list" prepend-icon="business_center" no-action>
                      <v-list-tile slot="activator">
                        <v-list-tile-title>Clients</v-list-tile-title>
                      </v-list-tile>

                      <v-list-tile @click="dialogNewClient = true">
                        <v-list-tile-title>Add a client</v-list-tile-title>
                        <v-icon>add</v-icon>
                      </v-list-tile>

                      <v-list-tile v-for="(client, i) in clients" :key="i" @click="displayClient(client)">
                        <v-list-tile-title v-text="client.name"></v-list-tile-title>
                      </v-list-tile>

                  </v-list-group>

                  <v-list-group id="users-list" prepend-icon="account_circle" no-action>
                    <v-list-tile slot="activator">
                      <v-list-tile-title>Users</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile @click="dialogNewUser = true">
                      <v-list-tile-title>Add a user</v-list-tile-title>
                      <v-icon>person_add</v-icon>
                    </v-list-tile>

                    <v-list-tile v-for="(user, i) in users" :key="i" @click="displayUser(user)">
                      <v-list-tile-title v-text="user.firstName + ' ' + user.lastName"></v-list-tile-title>
                    </v-list-tile>

                  </v-list-group>

                </v-list>
              </v-navigation-drawer>
          </v-card>
        </v-flex>
        <v-flex xs8>
          <v-card class="elevation-12" style="margin-bottom: 40px;">
              <FileManager :client="selectedClient"></FileManager>
          </v-card>
        </v-flex>
    </v-layout>
    <v-layout row wrap>
        <v-flex xs4>
        </v-flex>
        <v-flex xs8>
          <v-card class="elevation-12">
            <UserManager v-if="selectedUser" :user="selectedUser"></UserManager>
          </v-card>
        </v-flex>
   </v-layout>

  </div>

</template>

<script>
  import firebase from 'firebase'
  import db from '../../main.js'
  import {store} from '../../store/store.js'
  import Vuex from 'vuex'
  import Upload from '../Upload'
  import FileManager from './FileManager.vue'
  import UserManager from './UserManager.vue'

  export default {
    name: 'home',
    components: {
      Upload, FileManager, UserManager
    },
    data: function() {
      return {
        id: firebase.auth().currentUser.uid,
        firstName: null,
        lastName: null,
        email: null,
        company: null,
        isAdmin: null,
        selectedClient: {uid:""},
        clients: [],
        users: [],
        dialogNewClient: false,
        dialogNewUser: false,
        newClientName: null,
        selectedUser: null,
        newFirstName: null,
        newLastName: null,
        newEmail: null,
        newPassword: null,
        newCompany: null,
        newIsAdmin: false,
        newIsSuspended: false,
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ]
      }
    },
    mounted() {
      db.collection('users').where('id', '==', this.id).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(doc.id, ' => ', doc.data())
          this.uid = doc.id,
          this.firstName = doc.data().firstName,
          this.lastName = doc.data().lastName,
          this.company = doc.data().company
        })
      }),
      db.collection('users').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          let data = {
            'id': doc.data().id,
            'uid': doc.id,
            'firstName': doc.data().firstName,
            'lastName': doc.data().lastName,
            'email': doc.data().email,
            'isAdmin': doc.data().isAdmin,
            'company': doc.data().company
          }
          this.users.push(data)
        })
      }),
      db.collection('companies').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          let data = {
            'uid': doc.id,
            'name': doc.data().name
          }
          this.clients.push(data)
        })
      })
      // db.collection('videos').get().then((querySnapshot) => {
      //   this.loading = false
      //   querySnapshot.forEach((doc) => {
      //     let data = {
      //       'id': doc.id,
      //       'name': doc.data().name,
      //       'bucketRef': doc.data().bucketRef,
      //       'uploadDate': doc.data().uploadDate,
      //       'type': doc.data().type,
      //       'category': doc.data().category,
      //       'duration': doc.data().duration,
      //       'slug': doc.data().slug
      //     }
      //     this.allVideos.push(data)
      //     this.sortVideos(this.allVideos)
      //   })
      // })
    },
    methods: {
      generatePassword() {
        this.newPassword = Math.random().toString(36).slice(-8);
      },
      logout: function() {
        firebase.auth().signOut().then(() => {
          this.$store.dispatch('setUser')
          this.$router.replace('login')
        })
      },
      displayUser(user) {
          this.selectedUser = user;
      },
      displayClient(client) {
          this.selectedClient = client;
      },
      createNewClient() {
        var self = this;
        db.collection('companies').add({
          name: this.newClientName
        })
          .then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            self.dialogNewClient = false;
          })
          .catch(function (error) {
            console.error('Error adding document: ', error)
          })
      },
      createNewUser() {
        var self = this;
        var createNewUser = firebase.functions().httpsCallable('createNewUser');
        console.log("New Email: " + this.newEmail);
        console.log("New Password: " + this.newPassword);
        createNewUser({email: this.newEmail, pass: this.newPassword}).then(function(result) {
          console.log(result);
          db.collection('users').add({
            id: result.data.uid,
            firstName: self.newFirstName,
            lastName: self.newLastName,
            email: self.newEmail,
            company: self.newCompany,
            isAdmin: self.newIsAdmin,
            isSuspended: self.newIsSuspended
          }).then(() => {
            self.dialogNewUser = false;
            document.location.reload()
          })
        }).catch(function(error) {
          // Getting the Error details.
          console.log(error.code);
          console.log(error.message);
          console.log(error.details);
        });
      },
      // getUserRole: function(isAdmin, isSuperAdmin) {
      //   if (isAdmin == true) {
      //     if (isSuperAdmin == true) {
      //       return "Administrator"
      //     } else {
      //       return "Sales Manager"
      //     }
      //   } else {
      //     return "Sales Team Member"
      //   }
      // },
      // assignEditUserData(user) {
      //   this.editId = user.uid,
      //   this.editEmail = user.email,
      //   this.editFirstName = user.firstName,
      //   this.editLastName = user.lastName,
      //   this.editAddress = user.address,
      //   this.editUserRole = user.userRole,
      //   this.editManager = user.manager,
      //   this.editTitle = user.title,
      //   this.editRegion = user.region,
      //   this.editIsAdmin = user.isAdmin,
      //   this.editIsSuperAdmin = user.isSuperAdmin
      // },
      // editUser() {
      //   console.log(this.editId);
      //   if (this.editUserRole == "admin") {
      //     this.editIsSuperAdmin = false;
      //     this.editIsAdmin = true;
      //   } else if (this.editUserRole == "superAdmin") {
      //     this.editIsSuperAdmin = true;
      //     this.editIsAdmin = true;
      //   }
      //   db.collection("users").doc(this.editId).update({
      //       'firstName': this.editFirstName,
      //       'lastName': this.editLastName,
      //       'email': this.editEmail,
      //       'address': this.editAddress,
      //       'isAdmin': this.editIsAdmin,
      //       'isSuperAdmin': this.editIsSuperAdmin,
      //       'title': this.editTitle,
      //       'manager': this.editManager,
      //       'region': this.editRegion
      //   })
      //   .then(function() {
      //       console.log("User successfully updated!");
      //       document.location.reload();
      //   });
      // },
      // deleteUser(user) {
      //   var self = this;
      //   var userConfirm = confirm("Are you sure you want to delete " + user.firstName + " " + user.lastName + "?");
      //   if (userConfirm == true) {
      //     db.collection("users").doc(user.id).delete().then(function() {
      //       self.showDismissibleAlert=true;
      //       console.log(user + " deleted");
      //       document.location.reload();
      //     }).catch(function(error) {
      //       console.log("There was an error deleting this user " + error);
      //     });
      //   } else {
      //     console.log(this.playlists)
      //     console.log(this.managers)
      //     console.log(this.numberOfVideosByTeamChart)
      //     console.log("You just saved somebody's life");
      //   }
      // },
      // deleteVideo(video) {
      //   var userConfirm = confirm("Are you sure you want to delete " + video.name + "?");
      //   if (userConfirm == true) {
      //     db.collection("videos").doc(video.id).delete().then(function() {
      //       self.showDismissibleAlert=true;
      //       console.log(video + " deleted");
      //       document.location.reload();
      //     }).catch(function(error) {
      //       console.log("There was an error deleting this user " + error);
      //     });
      //   } else {
      //     console.log("You just saved somebody's life");
      //   }
      // },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  h1 {
      text-align: center;
  }

  a {
      text-decoration: none;
      color: #1a1a1a;
  }

  .admin {
      width: 100%;
  }

  #users-list {
    max-height: 480px;
    overflow: auto;
  }

  #clients-list {
    max-height: 480px;
    overflow: auto;
  }

</style>
